import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import HomePage from "./pages/HomePage";
import SizeSelection from "./pages/SizeSelection";
import FloorSelection from "./pages/FloorSelection";
import AddressInput from "./pages/AddressInput";
import RouteMap from "./pages/RouteMap";
import AdditionalServices from "./pages/AdditionalServices";
import FinalQuote from "./pages/FinalQuote";
import { Toaster } from "./components/ui/toaster";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/size-selection" element={<SizeSelection />} />
          <Route path="/floor-selection" element={<FloorSelection />} />
          <Route path="/address-input" element={<AddressInput />} />
          <Route path="/route-map" element={<RouteMap />} />
          <Route path="/additional-services" element={<AdditionalServices />} />
          <Route path="/final-quote" element={<FinalQuote />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;